<script setup lang="ts">
// Nuxt error boundary — before this file, an unmatched route fell through to
// the framework's unbranded default page with no way back into the app. Kept
// deliberately minimal: no AppNav (no session/middleware context out here),
// just the brand shell and two ways home. clearError must reset the error
// state before leaving or the SPA stays wedged on the boundary.
import type { NuxtError } from '#app'

const props = defineProps<{ error: NuxtError }>()
const notFound = computed(() => props.error?.statusCode === 404)
function goHome() { clearError({ redirect: '/' }) }
function goScores() { clearError({ redirect: '/scoreboard' }) }
</script>

<template>
  <div class="err-shell">
    <header class="top">
      <div class="brand">
        <img src="/BuzztimeLogo.webp" class="logo" alt="Buzztime" />
        <span class="dom">ProBook</span>
      </div>
    </header>
    <div class="wrap err-wrap">
      <div class="err-card">
        <div class="err-code mono">{{ error?.statusCode || 500 }}</div>
        <h1 v-if="notFound">page not found</h1>
        <h1 v-else>something went wrong</h1>
        <p v-if="notFound" class="err-sub">That page doesn't exist — it may have moved or the link is stale.</p>
        <p v-else class="err-sub">An unexpected error occurred. Your bets and balances are unaffected.</p>
        <div class="err-actions">
          <button class="btn-ghost" @click="goHome">← book</button>
          <button class="btn-ghost" @click="goScores">scores</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.err-wrap { display: flex; justify-content: center; padding-top: 8vh; }
.err-card { text-align: center; background: var(--panel); border: 1px solid var(--line);
  border-radius: 14px; padding: 40px 48px; max-width: 460px; }
.err-code { font-size: 44px; font-weight: 800; color: var(--accent); letter-spacing: 0.06em; }
.err-card h1 { font-size: 20px; margin-top: 6px; }
.err-sub { color: var(--muted); font-size: 14px; margin-top: 10px; }
.err-actions { display: flex; justify-content: center; gap: 12px; margin-top: 22px; }
</style>
